import themeGet from '@styled-system/theme-get';
import * as T from 'prop-types';
import styled from 'styled-components/macro';
import styledMap from 'styled-map';

import { Flex } from '@olist/united';

import StepCardList from './step-card-list';
import StepDescription from './step-description';
import StepTitle, { TitleWrapper } from './step-title';

const StepWrapper = styled(Flex).attrs({
  marginLeft: 8,
})`
  ${TitleWrapper} {
    margin-left: -42px;
    z-index: 2;
  }

  @media (max-width: ${themeGet('breakpoints.0')}) {
    margin-left: 0;
    ${TitleWrapper} {
      margin-left: -15px;
    }
  }

  &:not(:last-child) {
    padding-bottom: ${themeGet('space.4')}px;
    position: relative;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }

  &:before {
    background-color: ${styledMap({
      default: themeGet('colors.foundation.shadeLight'),
      isCompleted: themeGet('colors.foundation.successDefault'),
      isWarning: themeGet('colors.foundation.warningDefault'),
    })};
    content: '';
    height: calc(100% - 18px);
    left: -30px;
    position: absolute;
    top: 20px;
    width: 2px;
    z-index: 1;
  }
`;

const Step = ({ cards, description, title, ...props }) => (
  <StepWrapper flexDirection="column" {...props}>
    <StepTitle {...props}>{title}</StepTitle>
    {description && <StepDescription>{description}</StepDescription>}
    {cards?.length > 0 && <StepCardList cards={cards} />}
  </StepWrapper>
);

Step.propTypes = {
  /**
   * What is the Step's title?
   */
  title: T.node.isRequired,
  /**
   * What is the Step's description?
   */
  description: T.node,
  /**
   * What is the Step's list of card properties?
   */
  cards: T.arrayOf(
    T.shape({
      isActive: T.bool,
      isCompleted: T.bool,
      isLoading: T.bool,
      isLocked: T.bool,
      title: T.string.isRequired,
    })
  ),
};

Step.defaultProps = {
  cards: [],
  description: null,
};

export default Step;
